/** Build an Arbiscan transaction URL (deposits/withdrawals — Arbitrum tx hash) */
export function getArbiscanTxUrl(txHash: string) {
	return `https://arbiscan.io/tx/${txHash}`;
}

/** Build a Hyperliquid L1 explorer URL (fills, funding, transfers — HyperBFT hash) */
export function getHyperliquidExplorerTxUrl(txHash: string) {
	return `https://app.hyperliquid.xyz/explorer/tx/${txHash}`;
}
